import fetch from "auth/FetchInterceptor";

const AbandonedCartService = {};

AbandonedCartService.getAbandonedCarts = function (
  page = 1,
  pagelimit = 20,
  filters = {},
) {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pagelimit", pagelimit);

  if (filters.status) {
    params.append("status", filters.status);
  }
  if (filters.search != null && String(filters.search).trim() !== "") {
    params.append("search", String(filters.search).trim());
  }

  return fetch({
    url: `/abandoned-carts/?${params.toString()}`,
    method: "get",
  });
};

AbandonedCartService.sendReminder = function (cartId) {
  return fetch({
    url: `/abandoned-carts/${cartId}/send-reminder/`,
    method: "post",
  });
};

AbandonedCartService.getSettings = function () {
  return fetch({
    url: `/abandoned-cart-settings/`,
    method: "GET",
  });
};

AbandonedCartService.updateSettings = function (data) {
  return fetch({
    url: `/abandoned-cart-settings/`,
    method: "PUT",
    data,
  });
};

export default AbandonedCartService;
